/* eslint-disable react/no-array-index-key */
import SimpleCard from '../simpleCard/SimpleCard';
import { HeadingDescVsmall, SectionInnerHeading } from '../../Headings';
import heartRate from '../../../assets/images/svg/heart-pink.svg';
import oxygen from '../../../assets/images/svg/oxygen-green.svg';
import respiration from '../../../assets/images/svg/respiration-blue.svg';
import hrv from '../../../assets/images/svg/hrv-orange.svg';
import stressLevel from '../../../assets/images/svg/stress-level-yellow.svg';
import bp from '../../../assets/images/svg/bp-green.svg';
import './healthResultCards.css';

// const cardData = [
//   { title: 'Heart Rate', result: '56', unit: 'BPM', icon: heartRate },
//   { title: 'Oxygen Saturation', result: '98', unit: 'SOO2%', icon: oxygen },
//   {
//     title: 'Respiration Rate',
//     unit: 'RPM',
//     result: '56',
//     icon: respiration
//   },
//   { title: 'HRV-SDNN', result: '44.0', unit: 'MS', icon: hrv },
//   { title: 'Stress Level', result: 'low', unit: '', icon: stressLevel },
//   { title: 'Blood Pressure', result: '110/70', unit: 'mmHG', icon: bp }
// ];

const cardData = [
  { id: 'heart_rate', title: 'Heart Rate', unit: 'BPM', icon: heartRate },
  { id: 'oxygen', title: 'Oxygen Saturation', unit: 'SOO2%', icon: oxygen },
  {
    id: 'respiration',
    title: 'Respiration Rate',
    unit: 'RPM',
    icon: respiration
  },
  { id: 'hrv-sdnn', title: 'HRV-SDNN', unit: 'MS', icon: hrv },
  { id: 'stress', title: 'Stress Level', unit: '', icon: stressLevel },
  { id: 'bp', title: 'Blood Pressure', unit: 'mmHG', icon: bp }
];

// eslint-disable-next-line prettier/prettier
const getDefaultConfig = (array, title) => array.find((element) => element.id === title);

function HealthResultCards(props) {
  const { data } = props;
  return (
    <div className="healthResultCards">
      {data.map((item, index) => {
        const { title, unit, icon } = getDefaultConfig(cardData, item.id);
        return (
          item.value && (
            <SimpleCard key={index}>
              <HeadingDescVsmall text={<b>{title}</b>} />
              <div>
                <SectionInnerHeading text={item.value} />
                <HeadingDescVsmall text={unit} />
              </div>
              <img src={icon} alt="icon" className="icon" />
            </SimpleCard>
          )
        );
      })}
    </div>
  );
}

export default HealthResultCards;
